import { render, staticRenderFns } from "./TestimonialHomeTwo.vue?vue&type=template&id=1292de88"
import script from "./TestimonialHomeTwo.vue?vue&type=script&lang=js"
export * from "./TestimonialHomeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports